import { Checkbox, CheckboxProps } from '@mui/material';
import { VIEW_MODE } from '../../consts/enums';

type CustomCheckboxProps = CheckboxProps & {
  viewMode?: ViewMode,
};

const CustomCheckbox = ({
  viewMode,
  ...muiProps
}: CustomCheckboxProps): JSX.Element | null => {
  const isReadOnly = viewMode === VIEW_MODE.READ_ONLY;

  const combinedProps = {
    ...muiProps,
    disabled: isReadOnly,
  };

  if (viewMode === VIEW_MODE.HIDDEN) {
    return null;
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Checkbox { ...combinedProps } />
  );
};

CustomCheckbox.defaultProps = {
  viewMode: VIEW_MODE.READ_ONLY,
};

export default CustomCheckbox;
